import Project from '@/models/Project'

export default {
  props: {
    project: {
      type: Project,
      default: () => new Project()
    }
  },
  data () {
    return {
      projectId: this.$route.params.name
    }
  },
  methods: {
    loadData () { }
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.projectId = this.$route.params.name
    this.loadData()
  },
  mounted () {
    this.loadData()
  }
}
